import React, { forwardRef } from "react";
import PropTypes from "prop-types";

import styles from "./GlobalFooter.scss";

const GlobalFooterLink = forwardRef((props, ref) => {
  const { labelText, href, ...otherProps } = props;

  return (
    <a
      ref={ref}
      key={labelText}
      className={styles["footer-link"]}
      href={href}
      {...otherProps}
    >
      {labelText}
    </a>
  );
});

GlobalFooterLink.propTypes = {
  labelText: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
};

GlobalFooterLink.displayName = "GlobalFooter.Link";

export default GlobalFooterLink;
